import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AppState, Dispatch } from 'store/types'
import { fetchPhones } from 'ducks/footer/operations'
import { fetchPrivacyPolicy, fetchTerm } from 'ducks/privacyPolicy/operations'
import Footer from 'components/content/Footer'

class FooterContainer extends Component<Props, {}> {
  componentDidMount() {
    this.props.fetchPhones()
    this.props.fetchPrivacyPolicy()
    this.props.fetchTerm()
  }

  render() {
    return (
      <Footer 
        phones={this.props.phones}
        privacyPolicy={this.props.privacyPolicy}
        term={this.props.term}
      />
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {
  phones: any,
  privacyPolicy: any,
  term: any
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps & ReceivedProps

const mapStateToProps = (state: AppState) => ({
  phones: state.footer,
  privacyPolicy: state.privacyPolicy.privacyPolicy,
  term: state.privacyPolicy.term
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ 
    fetchPhones,
    fetchPrivacyPolicy,
    fetchTerm
  }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterContainer)
